import React, { useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Outlet, useLocation } from "react-router-dom";
import Drawer from "./Drawer";
import { useState } from "react";
export default function DashLayout() {
	const [isDrawerOpen, setDrawer] = useState(false);
	const location = useLocation();

	// close the mobile drawer whenever the route changes
	useEffect(() => {
		setDrawer(false);
	}, [location.key]);

	return (
		<>
			<div className="container-wrapper">
				<Navbar func={setDrawer} isDrawerOpen={isDrawerOpen} />
				{/* the drawer overlays the page, so the current view keeps its data */}
				<Drawer isDrawerOpen={isDrawerOpen} setDrawer={setDrawer} />
				<div className="layout">
					<Sidebar />
					<div className="content">
						<Outlet />
					</div>
				</div>
			</div>
		</>
	);
}
